// extracted by mini-css-extract-plugin
export var chevronIcon = "_9q-2";
export var teamName = "_9q-1";
export var teamSwitcherButton = "_9q-0";